import { useNavigate } from 'react-router-dom';
import Button from '../../components/Button';
import styles from './style.module.scss';
import { NotFoundIllustration } from '../../assets/images';

function NoFoundPage() {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <NotFoundIllustration />
                <span className={styles.header}>
                    Page not found.
                </span>
                <span className={styles.description}>
                    The page you are looking for might have been removed.
                </span>
                <Button text='Return to home' onClick={() => navigate('/')} />
            </div>
        </div>
    );
};

export default NoFoundPage;
